<template>

        <conteudo  :ajax="false">

            <div id="equipesinscritas">
                <h1> Procuro Equipe </h1>

                <div>
                    <h6>Disponibilizamos abaixo um sistema de discussão para as pessoas procurando por equipes entrarem em contato.</h6>
                    <h6><strong>Para quem procura uma equipe:</strong></h6>
                    <p>Deixe uma mensagem abaixo especificando o tipo de equipe que procura(ex: Procuro equipe de quadra mista).</p>
                    <h6><strong>Para equipes procurando Atletas:</strong></h6>
                    <p>Responda aos requesitos abertos</p>
                </div>



                  <div id="disqus_thread"></div>
    
            </div>  
           
                

        </conteudo>

</template>


<script>
    import Conteudo from './conteudo.vue'
    // import marked from 'marked'

    export default {
        data(){
            return{}
        },

        components: {
            'conteudo':Conteudo
        },

        mounted:function(){

            this.$nextTick( ()=>{
            var disqus_shortname = 'voltadolago'; 
            var dsq = document.createElement('script'); dsq.type = 'text/javascript'; dsq.async = true;
            dsq.src = '//' + disqus_shortname + '.disqus.com/embed.js';
            (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(dsq);
           
            })
        },

        methods:{
            // getURL:function(){
            //      return `${window.API.apiurl}index.php?cID=328&isAjax=1`
            // }
    
        }


    }
    
</script>



<style lang="stylus">
    // @import "./../css/variaveis"


</style>